/* ============================================================
   REVIELLE — scroll reveal
   Adds .rv-reveal + .rv-in to content blocks as they enter view.
   Fails open: if anything throws, every tagged element is
   un-hidden immediately, so content is never lost.
   ============================================================ */

(function () {
  'use strict';

  var SELECTOR = [
    '[class*="group-block"]',
    '[class*="card"]',
    'h1', 'h2', 'h3', 'h4',
    'p', 'ul', 'ol',
    'img', 'video',
    'details',
    'blockquote',
    'a.button', 'button.button'
  ].join(',');

  var STAGGER = 120; // ms between siblings
  var MAX_STEPS = 6; // cap so long columns don't drag

  var observer = null;
  var tagged = [];

  function unhideAll() {
    for (var i = 0; i < tagged.length; i++) {
      tagged[i].classList.remove('rv-reveal', 'rv-in', 'rv-reveal--left', 'rv-reveal--right');
    }
    tagged = [];
  }

  function reveal(el) {
    el.classList.add('rv-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            reveal(entries[i].target);
            observer.unobserve(entries[i].target);
          }
        }
      },
      // Waits until the element is ~14% up from the bottom edge before firing,
      // so the travel is visible on screen instead of happening off-frame.
      { rootMargin: '0px 0px -14% 0px', threshold: 0.05 }
    );
    return observer;
  }

  // Elements sitting side by side get a horizontal entry, alternating
  // in from the left and right. Stacked elements just rise.
  function applyDirection(el, index) {
    var parent = el.parentElement;
    if (!parent) return;
    var sibs = [];
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].classList.contains('rv-reveal')) sibs.push(parent.children[i]);
    }
    if (sibs.length < 2) return;
    var a = sibs[0].getBoundingClientRect();
    var b = sibs[1].getBoundingClientRect();
    // Same row => laid out horizontally.
    if (Math.abs(a.top - b.top) < 40 && a.width < parent.getBoundingClientRect().width * 0.9) {
      el.classList.add(index % 2 === 0 ? 'rv-reveal--left' : 'rv-reveal--right');
    }
  }

  function tagSection(section, isFirst) {
    // The first section holds the product images, price and add-to-cart.
    // It must be visible instantly — never animate the buy box.
    if (isFirst) return;

    var candidates = section.querySelectorAll(SELECTOR);
    var chosen = [];

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.classList.contains('rv-reveal')) continue;
      if (el.parentElement && el.parentElement.closest('.rv-reveal')) continue;
      if (el.closest('.rv-reveal')) continue;
      el.classList.add('rv-reveal');
      chosen.push(el);
    }

    var io = getObserver();
    for (var j = 0; j < chosen.length; j++) {
      chosen[j].style.setProperty('--rv-d', Math.min(j, MAX_STEPS) * STAGGER + 'ms');
      applyDirection(chosen[j], j);
      io.observe(chosen[j]);
      tagged.push(chosen[j]);
    }
  }

  // Templates that must NOT animate. The prelander is meant to read as a
  // plain third-party article, so it gets no motion at all.
  var NO_REVEAL = ['prelander'];

  function revealDisabledFor(main) {
    var t = (main && main.dataset && main.dataset.template) || '';
    for (var i = 0; i < NO_REVEAL.length; i++) {
      if (t.indexOf(NO_REVEAL[i]) !== -1) return true;
    }
    return false;
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (revealDisabledFor(main)) return;

    var sections = main.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      tagSection(sections[i], i === 0);
    }

    // Anything already on screen at load reveals on the next frame,
    // so the first paint still animates in rather than popping.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        for (var k = 0; k < tagged.length; k++) {
          var r = tagged[k].getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) reveal(tagged[k]);
        }
      });
    });
  }

  function boot() {
    try {
      if (!('IntersectionObserver' in window) || !Element.prototype.closest) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      init();
    } catch (e) {
      unhideAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections on every edit — re-tag the new markup.
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 60);
  });

  // Last-resort safety net: nothing stays invisible for more than 5s.
  window.setTimeout(function () {
    for (var i = 0; i < tagged.length; i++) {
      var r = tagged[i].getBoundingClientRect();
      if (r.top < window.innerHeight * 1.5) reveal(tagged[i]);
    }
  }, 5000);
})();

/* ============================================================
   REVIELLE — purchase micro-interactions
   Offer-picker selection feedback and add-to-cart commit feedback.
   Purely additive: adds a class, removes it when the animation ends.
   ============================================================ */

(function () {
  'use strict';

  function flash(el, className, ms) {
    if (!el) return;
    el.classList.remove(className);
    // Force a reflow so the animation restarts on repeat clicks.
    void el.offsetWidth;
    el.classList.add(className);
    window.setTimeout(function () {
      el.classList.remove(className);
    }, ms);
  }

  // --- Offer picker: pop the card, its price and its badge on selection ---
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('goda-tier__input')) return;

      var card = input.closest('.goda-tier');
      flash(card, 'rv-picked', 500);

      // The picker rewrites the quantity field; nudge it so the change is noticed.
      var form = document.querySelector('form[action*="/cart/add"]');
      var qty = form && form.querySelector('input[name="quantity"]');
      var qtyBox = qty && qty.closest('[class*="quantity"]');
      flash(qtyBox || qty, 'rv-qty-bumped', 450);
    },
    true
  );

  // --- Add to cart: press-in on commit ---
  document.addEventListener(
    'click',
    function (event) {
      var el = event.target;
      if (!el || !el.closest) return;
      var btn = el.closest('button, .button');
      if (!btn) return;
      var inAddToCart =
        btn.closest('[class*="add-to-cart"]') ||
        btn.getAttribute('name') === 'add' ||
        btn.type === 'submit';
      if (!inAddToCart) return;
      if (!btn.closest('form[action*="/cart/add"]')) return;
      flash(btn, 'rv-atc-pressed', 470);
    },
    true
  );
})();

/* ============================================================
   REVIELLE — savings banner above the offer picker
   Shows the % saved for the selected offer and updates on change.

   The percentage is DERIVED, never hardcoded: unit retail comes from
   the first tier's own crossed-out price, and every figure is rounded
   DOWN to the nearest 5. The shopper is therefore always told they
   save slightly less than they actually do.
   ============================================================ */

(function () {
  'use strict';

  var TAG_ICON =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M10.6 2.3H16a1.7 1.7 0 0 1 1.7 1.7v5.4a1.7 1.7 0 0 1-.5 1.2l-6.4 6.4a1.7 1.7 0 0 1-2.4 0l-5.4-5.4a1.7 1.7 0 0 1 0-2.4l6.4-6.4a1.7 1.7 0 0 1 1.2-.5z"/>' +
    '<circle cx="13.6" cy="6.4" r="1.1" fill="currentColor" stroke="none"/></svg>';

  function money(str) {
    if (!str) return 0;
    var n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function qtyOf(card) {
    var input = card.querySelector('.goda-tier__input');
    var n = input ? parseInt(input.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  // Retail for one unit, taken from whichever tier gives us a crossed-out
  // price alongside a known quantity. Falls back to the plain price.
  function unitRetail(root) {
    var cards = root.querySelectorAll('.goda-tier');
    for (var i = 0; i < cards.length; i++) {
      var compare = money(cards[i].querySelector('.goda-tier__compare') &&
        cards[i].querySelector('.goda-tier__compare').textContent);
      if (compare > 0) {
        var q = qtyOf(cards[i]);
        // Only trust a compare-at that is stated per single unit.
        if (q === 1) return compare;
      }
    }
    for (var k = 0; k < cards.length; k++) {
      if (qtyOf(cards[k]) === 1) {
        var p = money(cards[k].querySelector('.goda-tier__price') &&
          cards[k].querySelector('.goda-tier__price').textContent);
        if (p > 0) return p;
      }
    }
    return 0;
  }

  function savingsPct(card, unit) {
    if (!unit) return 0;
    var priceEl = card.querySelector('.goda-tier__price');
    var price = money(priceEl && priceEl.textContent);
    var retail = unit * qtyOf(card);
    if (!price || !retail || price >= retail) return 0;
    var raw = (1 - price / retail) * 100;
    return Math.floor(raw / 5) * 5; // round down — always under-claim
  }

  function build(root) {
    var banner = document.createElement('div');
    banner.className = 'rv-savings';
    banner.setAttribute('role', 'status');
    banner.innerHTML =
      '<span class="rv-savings__icon">' + TAG_ICON + '</span>' +
      '<span class="rv-savings__copy">' +
      '<span class="rv-savings__headline">You are saving ' +
      '<span class="rv-savings__pct">0%</span> on this order</span>' +
      '<span class="rv-savings__note">Applied automatically at checkout &mdash; no code needed.</span>' +
      '</span>';

    var list = root.querySelector('.goda-tiers__list');
    if (list && list.parentNode) list.parentNode.insertBefore(banner, list);
    else root.insertBefore(banner, root.firstChild);
    return banner;
  }

  function update(root, banner, unit, animate) {
    var card = root.querySelector('.goda-tier.is-selected') || root.querySelector('.goda-tier');
    if (!card) return;
    var pct = savingsPct(card, unit);
    var el = banner.querySelector('.rv-savings__pct');
    var next = pct + '%';
    banner.style.display = pct > 0 ? '' : 'none';
    if (el.textContent === next) return;
    el.textContent = next;
    if (animate) {
      banner.classList.remove('rv-bumped');
      void banner.offsetWidth;
      banner.classList.add('rv-bumped');
      window.setTimeout(function () { banner.classList.remove('rv-bumped'); }, 460);
    }
  }

  function mount() {
    var roots = document.querySelectorAll('.goda-tiers');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        if (root.dataset.rvSavings === 'true') return;
        root.dataset.rvSavings = 'true';

        var unit = unitRetail(root);
        if (!unit) return;

        var banner = build(root);
        update(root, banner, unit, false);

        root.addEventListener('change', function () {
          // Run after the picker has moved its own is-selected class.
          window.setTimeout(function () { update(root, banner, unit, true); }, 0);
        });
      })(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mount, 60);
  });
})();

/* ============================================================
   REVIELLE — sticky bar price follows the selected offer
   The sticky bar renders the raw product price ($117). The shopper
   never pays that, so show what the chosen offer actually costs
   with the retail price struck through beside it.
   ============================================================ */

(function () {
  'use strict';

  function selectedTier() {
    var input = document.querySelector('.goda-tier__input:checked');
    if (!input) return null;
    var card = input.closest('.goda-tier');
    if (!card) return null;
    var price = card.querySelector('.goda-tier__price');
    var compare = card.querySelector('.goda-tier__compare');
    return {
      price: price ? price.textContent.trim() : '',
      compare: compare ? compare.textContent.trim() : ''
    };
  }

  function markup(tier) {
    if (!tier || !tier.price) return null;
    var html = '<span class="price rv-sticky-price">' + tier.price + '</span>';
    if (tier.compare && tier.compare !== tier.price) {
      html += '<span class="compare-at-price rv-sticky-compare">' + tier.compare + '</span>';
    }
    return html;
  }

  // Everywhere the product price is printed inside the buy box: the big number
  // above the bullets, and the sticky bar. Both render the raw $117, which is
  // never what the shopper pays.
  function targets() {
    var out = [];
    var bar = document.querySelector('.sticky-add-to-cart__price');
    if (bar) out.push(bar);

    // Anchor on the offer picker and walk up to its section. Section ids in
    // JSON templates are `shopify-section-template--<id>__main`, so matching
    // on a fixed id does not work.
    var picker = document.querySelector('.goda-tiers');
    var scope = picker ? picker.closest('.shopify-section') : null;
    if (!scope) {
      var form = document.querySelector('form[action*="/cart/add"]');
      scope = form ? form.closest('.shopify-section') : null;
    }
    if (scope) {
      var mains = scope.querySelectorAll('[ref="priceContainer"]');
      for (var i = 0; i < mains.length; i++) {
        if (mains[i].closest('.sticky-add-to-cart')) continue;
        if (mains[i].closest('.goda-tiers')) continue;
        if (mains[i].closest('[class*="product-card"]')) continue;
        out.push(mains[i]);
      }
    }
    return out;
  }

  var desired = null;

  function sync(animate) {
    var html = markup(selectedTier());
    if (!html) return;
    desired = html;
    var nodes = targets();
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.innerHTML === html) continue;
      node.innerHTML = html;
      if (animate) {
        (function (el) {
          if (!el) return;
          el.classList.add('rv-bumped');
          window.setTimeout(function () { el.classList.remove('rv-bumped'); }, 460);
        })(node.querySelector('.rv-sticky-price'));
      }
    }
  }

  function guard() {
    if (!window.MutationObserver) return;
    var nodes = targets();
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        if (node.dataset.rvGuarded === 'true') return;
        node.dataset.rvGuarded = 'true';
        // The theme re-renders these on variant/quantity updates; put our
        // markup back whenever it does. Comparing first stops an observer loop.
        new MutationObserver(function () {
          if (desired && node.innerHTML !== desired) sync(false);
        }).observe(node, { childList: true, subtree: true });
      })(nodes[i]);
    }
  }

  function boot() {
    sync(false);
    guard();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('goda-tier__input')) {
        window.setTimeout(function () { sync(true); }, 0);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 80);
  });
})();

/* The testimonial carousel now lives in blocks/revielle-carousel.liquid so
   its speed, dots and card width are editable in the theme editor. Only the
   shared layout CSS for .rv-carousel stays in the stylesheet. */

/* ============================================================
   REVIELLE — go straight to checkout after adding
   The theme adds to cart over AJAX, so the page never moves and the
   shopper has to find the cart icon themselves. Watch for a successful
   POST to /cart/add and send them to checkout instead.

   The cart page is skipped deliberately: this is a one-product store
   with the bundle already chosen on the product page, so the cart step
   reviews nothing the checkout summary does not already show. Restore
   CART_URL here if order bumps are ever added to the cart page.

   Covers every add-to-cart on the page — the main button, the sticky
   bar and any quick-add — because it hooks the request, not the button.
   ============================================================ */

(function () {
  'use strict';

  if (!window.fetch) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECKOUT_URL = root.replace(/\/+$/, '') + '/checkout';
  var DELAY = 320; // let the button's press animation finish first

  var going = false;

  function goToCheckout() {
    if (going) return;
    going = true;
    window.setTimeout(function () {
      window.location.href = CHECKOUT_URL;
    }, DELAY);
  }

  function urlOf(input) {
    try {
      if (typeof input === 'string') return input;
      if (input instanceof Request) return input.url;
      if (input && input.url) return String(input.url);
      if (input && input.toString) return input.toString();
    } catch (e) {}
    return '';
  }

  function isAddToCart(url) {
    if (!url) return false;
    // /cart/add and /cart/add.js, with or without a locale prefix
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = nativeFetch.apply(this, arguments);
    try {
      if (isAddToCart(urlOf(input))) {
        promise.then(
          function (res) { if (res && res.ok) goToCheckout(); },
          function () {}
        );
      }
    } catch (e) {}
    return promise;
  };

  // Belt and braces for any code path still using XMLHttpRequest.
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (String(method).toUpperCase() === 'POST' && isAddToCart(String(url))) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) goToCheckout();
          });
        }
      } catch (e) {}
      return open.apply(this, arguments);
    };
  }
})();

/* ============================================================
   REVIELLE — guarantee line inside the buy button
   Stacks a small reassurance line beneath the button label, the way
   the offer pages do it. Injected rather than templated so Horizon's
   own add-to-cart snippet stays untouched and survives theme updates.

   The label itself is NOT set here — it comes from the locale key
   `actions.add_to_cart`, so it renders correct on first paint with
   no flash of the old wording.
   ============================================================ */

(function () {
  'use strict';

  var TEXT = '45-Night Money-Back Guarantee';

  var SHIELD =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M8 1.6l5 2v4.1c0 3-2.1 5.4-5 6.7-2.9-1.3-5-3.7-5-6.7V3.6l5-2z"/>' +
    '<path d="M5.9 8.1l1.5 1.5 3-3.1"/></svg>';

  function decorate(btn) {
    if (!btn || btn.dataset.rvSub === 'true') return;
    // The sticky bar's button is short and wide — a second line breaks it.
    if (btn.closest('.sticky-add-to-cart') || btn.closest('.rv-sticky')) return;
    btn.dataset.rvSub = 'true';

    // Move the label (and the cart icon, if the theme renders one) into
    // their own row so the guarantee sits beneath rather than beside it.
    var main = document.createElement('span');
    main.className = 'rv-atc-main';

    var kids = Array.prototype.slice.call(btn.childNodes);
    for (var i = 0; i < kids.length; i++) {
      var node = kids[i];
      // The checkmark burst is positioned over the button — leave it alone.
      if (node.nodeType === 1 && node.classList &&
          node.classList.contains('add-to-cart__added')) continue;
      main.appendChild(node);
    }
    btn.insertBefore(main, btn.firstChild);

    var sub = document.createElement('span');
    sub.className = 'rv-atc-sub';
    sub.innerHTML = '<span class="rv-atc-sub__icon">' + SHIELD + '</span>' + TEXT;
    btn.appendChild(sub);

    btn.classList.add('rv-atc-stacked');
  }

  function mount() {
    var btns = document.querySelectorAll('.add-to-cart-button, button[name="add"]');
    for (var i = 0; i < btns.length; i++) decorate(btns[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mount, 60);
  });
})();
